import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['theme', 'service', 'themeLink'];

	connect() {
		let firstTheme = this.themeTargets[0];
		let firstThemeID = firstTheme.dataset.themeId;
	
		this.setSubToggleActiveTheme(firstTheme);
		this.showRelevantServices(firstThemeID);
		this.setThemeLink(firstThemeID);
	}


	setThemeActive(e) {
		this.removeThemeSubToggles();
		this.hideAllServices();

		let themeContainer = e.target.closest('[data-theme-id]');
		let themeID = themeContainer.dataset.themeId;

		if (!themeContainer.hasAttribute('data-group-sub-toggle')) {
			themeContainer.setAttribute('data-group-sub-toggle', true);
		}

		this.setThemeLink(themeID);
		this.showRelevantServices(themeID);
	}

	removeAllActiveStates() {
		this.domainTargets.forEach((domain) => {
			if (domain.hasAttribute('data-group-toggle')) {
				domain.removeAttribute('data-group-toggle');
			}
		});
		this.themeTargets.forEach((theme) => {
			if (theme.hasAttribute('data-group-toggle')) {
				theme.removeAttribute('data-group-toggle');
			}
		});
		this.serviceTargets.forEach((service) => {
			if (service.hasAttribute('data-group-toggle')) {
				service.removeAttribute('data-group-toggle');
			}
		});
	}

	removeThemeSubToggles() {
		this.themeTargets.forEach((theme) => {
			if (theme.hasAttribute('data-group-sub-toggle')) {
				theme.removeAttribute('data-group-sub-toggle');
			}
		});
	}

	hideAllThemes() {
		this.themeTargets.forEach((theme) => {
			if (!theme.classList.contains('hidden')) {
				theme.classList.add('hidden');
			}
		});
	}

	hideAllServices() {
		this.serviceTargets.forEach((service) => {
			if (service.hasAttribute('data-group-toggle')) {
				service.removeAttribute('data-group-toggle');
			}
		});
	}
	setSubToggleActiveTheme(theme) {
		if (!theme.hasAttribute('data-group-sub-toggle')) {
			theme.setAttribute('data-group-sub-toggle', true);
		}
	}

	setThemeLink(themeID) {
		let themeLink = document.querySelector(`[data-theme-id="${themeID}"]`).dataset.themeLink;
		this.themeLinkTarget.href = themeLink; 
	}

	showRelevantServices(themeID) {
		this.serviceTargets.forEach((service) => {
			const themeIds = service.dataset.serviceThemeId.split(',').map(id => id.trim());
			themeIds.forEach((id) => {
				if(id == themeID) {
					service.setAttribute('data-group-toggle', true);
				}
			})
			
		});
	}
}
